<template>
  <DashboardCard
    :title="$t('My tasks')"
    :style="{ display: hasCompliances || hasInvitations ? 'block' : 'none' }"
    data-test="my-tasks-widget"
  >
    <WdsStack class="tw-py-4" direction-column gap-custom="16px">
      <HireInvitationsList @has-invitations="hasInvitations = $event" />
      <DashboardCompliances @has-compliances="handleComplianceChange" />
    </WdsStack>
  </DashboardCard>
</template>

<script setup lang="ts">
import { WdsStack } from '@worksome/wds-components'
import { ref } from 'vue'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import DashboardCard from '@/components/Dashboard/DashboardCard.vue'
import DashboardCompliances from '@/components/compliances/hooks/DashboardCompliances.vue'
import HireInvitationsList from '@/components/Hire/HireInvitationsList.vue'

const hasCompliances = ref(false)
const hasInvitations = ref(false)

const handleComplianceChange = (hasCompliancesToShow: boolean) => {
  hasCompliances.value = hasCompliancesToShow
}
</script>
